/* unplugin-vue-components disabled */import { render } from "./AIRoleSelector.vue?vue&type=template&id=2ced4f1e&scoped=true&ts=true"
import script from "./AIRoleSelector.vue?vue&type=script&lang=ts"
export * from "./AIRoleSelector.vue?vue&type=script&lang=ts"

import "./AIRoleSelector.vue?vue&type=style&index=0&id=2ced4f1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ced4f1e"]])

export default __exports__